import { Component, Input, Output, EventEmitter } from '@angular/core';

import { HeaderComponent } from '@shared/core/components/headers/header/header.shared.component';

@Component({
    selector: 'shared-short-message',
    templateUrl: './short-message.shared.component.html',
    styleUrls: ['./short-message.shared.component.scss']
})
export class ShortMessageComponent extends HeaderComponent {
    @Input() public title: string = '';
    @Input() public button: string = '';

    @Input() public type: OLO.Components.HEADER_TYPE = '2';
    @Input() public size: OLO.Components.BUTTON_SIZE = null;
    @Input() public inverted: boolean = false;
    @Input() public feel: OLO.Components.BUTTON_FEEL | OLO.Components.BUTTON_CIRCLE_FEEL = 'primary';
    @Input() public iconLeft: string = null;
    @Input() public iconRight: string = null;
    @Input() public role: string = null;
    @Input() public disabled: boolean = false;
    @Input() public width: OLO.Components.BUTTON_WIDTH = 'normal';

    @Output() public onClick: EventEmitter<Event> = new EventEmitter();

    public handleClick($event: Event): void {
        this.onClick.emit($event);
    }
}
